import { useEffect, useState } from "react";
import "./App.css";
import Loader from "./loader.gif";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { toast } from "react-toastify";

import Web3 from "web3";

// import Abis
import ExchangeAbi from "./contracts/Exchange.json";
import MercuryTokenAbi from "./contracts/MercuryToken.json";
import PlutoTokenAbi from "./contracts/PlutoToken.json";

import NavBar from "./Components/NavBar";
import BuyErc20 from "./Components/BuyErc20";

const App = () => {
  const [currentAccount, setCurrentAccount] = useState("");
  const [exchangeSm, setExchangeSm] = useState(null);
  const [mercurySm, setMercurySm] = useState(null);
  const [plutoSm, setPlutoSm] = useState(null);
  const [totalSold, setTotalSold] = useState(null);
  const [rate, setRate] = useState(null);
  const [plutoBalance, setPlutoBalance] = useState(0);
  const [mercuryBalance, setMercuryBalance] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadWeb3();
    loadBlockchainData();
  }, []);

  const loadWeb3 = async () => {
    if (window.ethereum) {
      await window.ethereum.enable();
    } else {
      toast("Please Connect To A Wallet. Try Using Metamask.", {
        type: "error",
        autoClose: 15000,
      });
    }
  };

  const loadBlockchainData = async () => {
    if (typeof window.ethereum == "undefined") {
      return;
    }

    const web3 = new Web3(window.ethereum);
    const accounts = await web3.eth.getAccounts();

    setCurrentAccount(accounts[0]);
    const networkId = await web3.eth.net.getId();
    if (networkId !== 4) {
      toast("Use Rinkeby Test network", { type: "error", autoClose: 15000 });
      return;
    }
    const exchangeNetworkData = ExchangeAbi.networks[networkId];
    const mercuryNetworkData = MercuryTokenAbi.networks[networkId];
    const plutoNetworkData = PlutoTokenAbi.networks[networkId];

    if (mercuryNetworkData) {
      const mercury = new web3.eth.Contract(
        MercuryTokenAbi.abi,
        mercuryNetworkData.address
      );
      setMercurySm(mercury);
      try {
        setIsLoading(true);
        const mercuryBalance = await mercury.methods
          .balanceOf(accounts[0])
          .call();
        setIsLoading(false);
        setMercuryBalance(Web3.utils.fromWei(mercuryBalance, "ether"));
      } catch {
        console.log("can't get balance");
      }
    }

    if (plutoNetworkData) {
      var pluto = new web3.eth.Contract(
        PlutoTokenAbi.abi,
        plutoNetworkData.address
      );
      setPlutoSm(pluto);
    }

    if (exchangeNetworkData) {
      toast("Hit refresh every time if you switch between accounts", {
        type: "info",
        autoClose: 10000,
      });

      const exchange = new web3.eth.Contract(
        ExchangeAbi.abi,
        exchangeNetworkData.address
      );
      setExchangeSm(exchange);

      try {
        setIsLoading(true);
        const plutoBalance = await pluto.methods
          .balanceOf(exchange._address)
          .call();
        setIsLoading(false);

        setPlutoBalance(Web3.utils.fromWei(plutoBalance, "ether"));
      } catch {
        console.log("can't get balance");
      }

      const totalSold = await exchange.methods.totalsold().call();
      const rate = await exchange.methods.rate().call();
      setTotalSold(totalSold);
      setRate(rate);
    }
  };

  const BuyTokens = async (amount) => {
    if (currentAccount) {
      setIsLoading(true);
      await mercurySm.methods
        .approve(exchangeSm._address, amount)
        .send({ from: currentAccount })
        .on("transactionHash", (hash) => {});
      setIsLoading(false);

      setIsLoading(true);
      await exchangeSm.methods
        .buyTokens(amount)
        .send({ from: currentAccount })
        .on("transactionHash", (hash) => {});

      setIsLoading(false);
      toast("Transaction Successfull", { type: "success" });

      //await mercurySm.methods.approve(amount).call();
      //await exchangeSm.methods.buyTokens(amount).call();
    } else {
      toast("Login to your wallet or hit Refresh", {
        type: "info",
        autoClose: 7000,
      });
    }
  };

  return isLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <img src={Loader} alt="Loading..."></img>
    </div>
  ) : (
    <div>
      <NavBar address={currentAccount} />
      <ToastContainer />
      <div className="container mt-5 ">
        <div className="row">
          <main
            role="main"
            className="ml-auto mr-auto"
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              maxWidth: "600px",
            }}
          >
            <div className="content mr-auto ml-auto">
              <div id="content" className="mt-3">
                <div className="card mb-4">
                  <div className="card-body">
                    <h1 className="mt-3 text-center">
                      Exchange your Mercury with Pluto
                    </h1>
                    <BuyErc20
                      BuyTokens={BuyTokens}
                      TotalSold={totalSold}
                      Rate={rate}
                      PlutoBalance={plutoBalance}
                      MercuryBalance={mercuryBalance}
                      Loading={isLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default App;
